'use strict';

define([], function () {

    var hasCustomEventConstructor = false;
    if (typeof CustomEvent === 'function') {
        hasCustomEventConstructor = true;
    }

    var createEvent = void 0;
    if (hasCustomEventConstructor) {
        createEvent = function createEvent(name, data, options) {
            var bubbles = options.bubbles || false;
            var cancelable = options.cancelable || false;
            return new CustomEvent(name, {
                detail: data || {},
                bubbles: bubbles,
                cancelable: cancelable
            });
        };
    } else {
        createEvent = function createEvent(name, data, options) {
            var bubbles = options.bubbles || false;
            var cancelable = options.cancelable || false;
            var event = document.createEvent('CustomEvent');
            event.initCustomEvent(name, bubbles, cancelable, data);
            return event;
        };
    }

    return {
        hasCustomEventConstructor: hasCustomEventConstructor,
        createEvent: createEvent
    };
});

